export const COMPANY = {
  name: "Globe Vista Overseas Education",
  short: "Globe Vista",
  tagline: "Your Gateway to Global Success",
  founder: "Syed Moinuddin",
  phone: "+91 7416807560",
  phoneRaw: "+917416807560",
  email: "Globevistaoverseasedu@gmail.com",
  address: "Santosh Nagar, Hyderabad, Telangana, India",
  whatsappMsg: "Hi Globe Vista, I would like to book a free consultation for studying abroad.",
  instagram: "https://www.instagram.com/globevistaoverseas",
};

export const GALLERY_IMAGES = [
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_visa-to-dreams/artifacts/kvba5fcw_IMG-20251201-WA0061.jpg",
    alt: "Live IELTS speaking practice session at Globe Vista Santosh Nagar",
    caption: "IELTS Speaking Practice",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_visa-to-dreams/artifacts/yg43k7ww_IMG-20251201-WA0045.jpg",
    alt: "Trainer conducting a full IELTS batch at Globe Vista Hyderabad",
    caption: "Small-batch IELTS Coaching",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_visa-to-dreams/artifacts/zs2888w6_IMG-20251201-WA0065.jpg",
    alt: "Speaking session on Hyderabad topic during IELTS training",
    caption: "Speaking Module in Action",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_visa-to-dreams/artifacts/wqbetr0e_IMG-20251201-WA0035.jpg",
    alt: "Trainer explaining IELTS writing strategy at Globe Vista",
    caption: "Writing Strategy Class",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_visa-to-dreams/artifacts/y2qxq80i_IMG-20251201-WA0062.jpg",
    alt: "Students attending live class at Globe Vista Santosh Nagar",
    caption: "Classroom · Santosh Nagar",
  },
];

export const FOUNDER = {
  name: "Syed Moinuddin",
  role: "Founder & Lead Trainer",
  photo: "https://customer-assets-39nsmqrw.emergentagent.net/job_visa-to-dreams/artifacts/cxot8aox_Snapchat-1025997663.jpg",
  bio: "A passionate educator with over a decade of experience in language training and overseas admissions counselling. Syed Moinuddin founded Globe Vista with a single mission — to make world-class education accessible to every deserving student in Hyderabad. Under his mentorship, 1000+ students have secured admissions across the world's top universities.",
  credentials: [
    "10+ years in IELTS / PTE training",
    "Certified language trainer",
    "1000+ students mentored",
    "Trusted study-abroad counsellor",
  ],
};

export const WHY_CHOOSE = [
  { title: "Expert Trainers", desc: "Industry veterans with 10+ years of proven test-prep excellence.", icon: "GraduationCap" },
  { title: "Personalized Counselling", desc: "One-on-one guidance tailored to your profile and dream career.", icon: "UserRoundCog" },
  { title: "Transparent Fees", desc: "No hidden costs. Every rupee accounted for with itemised billing.", icon: "BadgeIndianRupee" },
  { title: "Result-Oriented Training", desc: "Data-driven curriculum with measurable band-score improvements.", icon: "TrendingUp" },
  { title: "Online & Offline", desc: "Learn from anywhere with flexible hybrid classroom formats.", icon: "Laptop" },
  { title: "Flexible Batches", desc: "Morning, evening and weekend slots that fit your schedule.", icon: "Clock" },
  { title: "Mock Tests", desc: "Weekly full-length simulations under real exam conditions.", icon: "FileCheck2" },
  { title: "End-to-End Support", desc: "From counselling to landing abroad — we walk the whole journey.", icon: "Plane" },
];

export const STUDY_ABROAD_SERVICES = [
  { title: "University Selection", desc: "Match with the right university based on profile and budget.", icon: "School" },
  { title: "Admission Guidance", desc: "Application strategy, deadlines, and documentation done right.", icon: "ClipboardCheck" },
  { title: "SOP & LOR Assistance", desc: "Craft compelling statements that admissions officers remember.", icon: "PenLine" },
  { title: "Student Visa Support", desc: "End-to-end visa filing with 98% success rate.", icon: "StampIcon" },
  { title: "Scholarship Guidance", desc: "Find and apply to scholarships worth crores every year.", icon: "Award" },
  { title: "Education Loans", desc: "Partnered with leading banks and NBFCs for hassle-free loans.", icon: "Landmark" },
  { title: "Pre-Departure Support", desc: "Forex, travel, accommodation and airport pickup guidance.", icon: "Luggage" },
];

export const LANGUAGE_TESTS = [
  { code: "IELTS", full: "International English Language Testing System", bands: "Band 7.5+ avg." },
  { code: "PTE", full: "Pearson Test of English", bands: "79+ avg." },
  { code: "GRE", full: "Graduate Record Examinations", bands: "320+ avg." },
  { code: "GMAT", full: "Graduate Management Admission Test", bands: "700+ avg." },
  { code: "SAT", full: "Scholastic Assessment Test", bands: "1450+ avg." },
  { code: "TOEFL", full: "Test of English as a Foreign Language", bands: "105+ avg." },
  { code: "CELPIP", full: "Canadian English Language Proficiency", bands: "CLB 9+ avg." },
  { code: "Duolingo", full: "Duolingo English Test", bands: "135+ avg." },
  { code: "Spoken English", full: "Fluency & Communication Skills", bands: "Certification" },
];

export const DESTINATIONS = [
  {
    country: "United Kingdom", short: "UK", image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=2000&auto=format&fit=crop",
    universities: ["Oxford", "Cambridge", "Imperial College", "UCL"],
    courses: ["Business", "Engineering", "Medicine", "Data Science"],
    scholarships: "Chevening, Commonwealth, GREAT",
    career: "2-yr Post-Study Work Visa"
  },
  {
    country: "United States", short: "USA", image: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?q=80&w=2000&auto=format&fit=crop",
    universities: ["Harvard", "MIT", "Stanford", "Columbia"],
    courses: ["CS", "MBA", "Data Analytics", "Finance"],
    scholarships: "Fulbright, Merit-based aid",
    career: "3-yr OPT for STEM"
  },
  {
    country: "Canada", short: "Canada", image: "https://images.unsplash.com/photo-1517935706615-2717063c2225?q=80&w=2000&auto=format&fit=crop",
    universities: ["U of Toronto", "UBC", "McGill", "Waterloo"],
    courses: ["Engineering", "Nursing", "IT", "Business"],
    scholarships: "Vanier, Ontario Graduate",
    career: "3-yr PGWP + PR pathway"
  },
  {
    country: "Australia", short: "Australia", image: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?q=80&w=2000&auto=format&fit=crop",
    universities: ["Melbourne", "ANU", "Sydney", "UQ"],
    courses: ["Nursing", "Engineering", "Accounting", "IT"],
    scholarships: "Australia Awards, Destination Australia",
    career: "2-4 yr Post-Study Work"
  },
  {
    country: "New Zealand", short: "New Zealand", image: "https://images.unsplash.com/photo-1589871173558-a37a8b417e40?q=80&w=2000&auto=format&fit=crop",
    universities: ["Auckland", "Otago", "Victoria", "Canterbury"],
    courses: ["IT", "Hospitality", "Agriculture", "Business"],
    scholarships: "NZ Excellence Awards",
    career: "3-yr Post-Study Work"
  },
  {
    country: "Ireland", short: "Ireland", image: "https://images.unsplash.com/photo-1590137704510-9118e9d6d376?q=80&w=2000&auto=format&fit=crop",
    universities: ["Trinity College", "UCD", "UCC", "DCU"],
    courses: ["Data Science", "Pharma", "Business", "AI"],
    scholarships: "Government of Ireland IES",
    career: "2-yr Stay-Back Visa"
  },
  {
    country: "Germany", short: "Germany", image: "https://images.unsplash.com/photo-1528728329032-2972f65dfb3f?q=80&w=2000&auto=format&fit=crop",
    universities: ["TU Munich", "Heidelberg", "RWTH Aachen", "LMU"],
    courses: ["Engineering", "Automotive", "Physics", "MSc"],
    scholarships: "DAAD, Deutschland Stipendium",
    career: "18-month Job Seeker Visa"
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Free Counselling", desc: "Understand your goals, budget and timeline.", icon: "MessagesSquare" },
  { n: "02", title: "Profile Evaluation", desc: "Academic, financial and language readiness audit.", icon: "SearchCheck" },
  { n: "03", title: "University Selection", desc: "Shortlist universities that match your profile.", icon: "Building2" },
  { n: "04", title: "Admission", desc: "Applications, SOPs, LORs, interviews handled end-to-end.", icon: "ClipboardCheck" },
  { n: "05", title: "Visa Processing", desc: "Documentation, financial statements and interview prep.", icon: "StampIcon" },
  { n: "06", title: "Fly Abroad", desc: "Forex, travel, accommodation and airport support.", icon: "PlaneTakeoff" },
];

export const TESTIMONIALS = [
  {
    name: "Ayesha Fatima", exam: "IELTS 8.0 · University of Toronto",
    photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=800&auto=format&fit=crop",
    quote: "Globe Vista transformed my dream into reality. From IELTS coaching to visa filing, every single step was smooth. The mentors truly care."
  },
  {
    name: "Rohan Verma", exam: "GRE 328 · Georgia Tech",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=800&auto=format&fit=crop",
    quote: "Personalised SOP guidance was a game-changer. Got into my top-choice university with a 40% scholarship. Forever grateful to Syed sir."
  },
  {
    name: "Sanjana Reddy", exam: "PTE 84 · Melbourne University",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop",
    quote: "The mock tests were tougher than the actual PTE! That preparation gave me the confidence to score 84 on my very first attempt."
  },
  {
    name: "Mohammed Irfan", exam: "IELTS 7.5 · TU Munich",
    photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=800&auto=format&fit=crop",
    quote: "Germany felt impossible with the language and paperwork. Globe Vista's team made it seamless. I'm now pursuing my MSc dream."
  },
  {
    name: "Priya Sharma", exam: "Duolingo 145 · UCD Dublin",
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=800&auto=format&fit=crop",
    quote: "Affordable, transparent and result-oriented. I recommend Globe Vista to every student from Hyderabad aiming abroad."
  },
];

export const FAQS = [
  {
    q: "Which country is best for Indian students to study abroad?",
    a: "It depends on your budget, course and career goals. Canada, UK, Australia and Germany are among the most popular for their post-study work rights and PR pathways. Our counsellors help you decide based on your specific profile."
  },
  {
    q: "Do you provide IELTS and PTE coaching in Santosh Nagar, Hyderabad?",
    a: "Yes! Our flagship centre is in Santosh Nagar, Hyderabad. We offer IELTS, PTE, GRE, GMAT, SAT, TOEFL, CELPIP, Duolingo and Spoken English coaching both online and offline."
  },
  {
    q: "How much does it cost to study abroad?",
    a: "Tuition ranges from ₹8-45 lakhs per year depending on the country and university. Living expenses vary between ₹6-15 lakhs annually. We help you find scholarships and education loans to reduce this burden."
  },
  {
    q: "Do you help with the education loan process?",
    a: "Absolutely. We are partnered with SBI, HDFC Credila, Axis, Avanse and international lenders like Prodigy Finance and MPower to secure the best loan terms for our students."
  },
  {
    q: "What is the success rate for student visas?",
    a: "Globe Vista maintains a 98% student visa success rate across all destinations, thanks to our meticulous documentation and mock interview practice."
  },
  {
    q: "Can I get a scholarship to study abroad?",
    a: "Yes, hundreds of scholarships are available. Our team helps you identify and apply to merit-based, need-based and country-specific scholarships suited to your profile."
  },
];

export const BLOG_POSTS = [
  {
    slug: "ielts-band-8-tips",
    category: "IELTS Tips",
    title: "10 Proven Strategies to Crack IELTS Band 8+",
    excerpt: "From time-management drills to speaking hacks, these battle-tested strategies helped 200+ Globe Vista students score Band 8 and above.",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?q=80&w=1200&auto=format&fit=crop",
    date: "Dec 2, 2025", read: "6 min read",
  },
  {
    slug: "pte-speaking-mistakes",
    category: "PTE Tips",
    title: "5 PTE Speaking Mistakes That Cost You 10 Marks",
    excerpt: "Avoid these common pronunciation and fluency traps that even advanced English speakers fall into during the PTE exam.",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1200&auto=format&fit=crop",
    date: "Nov 25, 2025", read: "4 min read",
  },
  {
    slug: "uk-visa-updates-2026",
    category: "Visa Updates",
    title: "UK Student Visa 2026: Everything You Must Know",
    excerpt: "New graduate route rules, financial requirements, and how to file a bulletproof UK Tier-4 application.",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1200&auto=format&fit=crop",
    date: "Nov 18, 2025", read: "8 min read",
  },
  {
    slug: "canada-pgwp-changes",
    category: "Study Abroad News",
    title: "Canada PGWP Changes: What Every Student Should Know",
    excerpt: "IRCC's latest post-graduation work permit updates and how they impact your PR pathway.",
    image: "https://images.unsplash.com/photo-1517935706615-2717063c2225?q=80&w=1200&auto=format&fit=crop",
    date: "Nov 10, 2025", read: "5 min read",
  },
  {
    slug: "top-scholarships-2026",
    category: "Scholarships",
    title: "Top 15 Fully-Funded Scholarships for Indian Students in 2026",
    excerpt: "Chevening, Fulbright, DAAD, Erasmus Mundus — a complete deep dive with application deadlines.",
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=1200&auto=format&fit=crop",
    date: "Oct 30, 2025", read: "10 min read",
  },
  {
    slug: "sop-that-worked",
    category: "University Admissions",
    title: "An SOP That Got Into MIT: Full Breakdown",
    excerpt: "Structure, tone and storytelling techniques from a real MIT admission letter — annotated by our founder.",
    image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=1200&auto=format&fit=crop",
    date: "Oct 22, 2025", read: "7 min read",
  },
];
